const CAP_MEMPOOL = {
  id: 271,
  title: "La Mempool",
  slug: "mempool",
  type: "lesson",
  category: "bitcoin-avanzado",
  level: "advanced",
  preview:
    "La mempool es la sala de espera donde se almacenan transacciones antes de ser procesadas por los mineros. Regula la carga, las comisiones y protege contra ataques.",
  sections: [
    {
      heading: "Introducción",
      text: [
        "Cuando un usuario de criptomonedas realiza una transacción, el primer lugar donde se registra es en la mempool. Una mempool es una memoria temporal intermedia donde se almacenan de forma momentánea las transacciones de los usuarios.",
        "Una vez que la transacción llega a este lugar, los mineros van seleccionando cuáles procesar. Es en este punto cuando la transacción realmente se hace efectiva y pasa a integrarse en la blockchain.",
        "Así, la mempool funciona como una sala de espera en la que las transacciones permanecen hasta ser procesadas por los mineros. En Bitcoin, las funciones de la mempool están reguladas por el BIP-35."
      ]
    },

    {
      heading: "¿Cómo funciona una mempool?",
      text: [
        "Una mempool es un espacio de almacenamiento temporal para las transacciones que aún no han sido confirmadas. En Bitcoin, su funcionamiento sigue normas definidas por el BIP-35. Para entenderlo mejor, podemos dividir el proceso en fases."
      ]
    },

    {
      heading: "Primera fase: Recepción de la transacción",
      text: [
        "En esta primera fase, la mempool recibe las transacciones que generan los usuarios dentro de la red. Cada usuario utiliza su monedero para crear una transacción, y este proceso normalmente tarda menos de 10 segundos.",
        "Una vez creada, la transacción se transmite a la red para iniciar su camino hacia la confirmación.",
        "Ahora bien, si cientos de miles de usuarios realizan transacciones simultáneamente, se genera un alto tráfico en la red, que debe ser gestionado de forma eficiente.",
        "Aquí es donde la mempool juega un papel crucial al recibir y almacenar todas estas transacciones hasta que los mineros puedan atenderlas."
      ]
    },

    {
      heading: "Segunda fase: Acceso a las transacciones",
      text: [
        "Durante esta fase, los mineros acceden a la mempool y seleccionan las transacciones que se incluirán en el siguiente bloque.",
        "Con cada transacción elegida, la mempool se aligera y la red se equilibra. Menos transacciones en la mempool equivalen a menos presión y a confirmaciones más rápidas.",
        "Por el contrario, cuando la mempool está llena, las confirmaciones tardan más, lo que lleva a los usuarios a pagar comisiones más altas para que sus transacciones tomen prioridad.",
        "Esta dinámica genera un mercado competitivo: cuanto mayor es la comisión pagada, más probable es que los mineros seleccionen la transacción."
      ]
    },

    {
      heading: "Analogía de la sala de espera",
      text: [
        "La mempool puede compararse con una sala de espera pública. Si hay pocas personas esperando, los agentes pueden atender rápidamente. Si la sala está abarrotada, el tiempo de espera aumenta.",
        "Lo mismo ocurre en Bitcoin: los mineros procesan rápido, pero si la mempool está saturada, tardan más en confirmar cada transacción. Esto incentiva el aumento de comisiones."
      ]
    },

    {
      heading: "Tabla del proceso",
      table: {
        columns: ["Etapa", "Descripción"],
        rows: [
          {
            "Etapa": "1. Recepción de la Transacción",
            "Descripción":
              "La mempool recibe las transacciones que generan los usuarios, proceso que no tarda más de 10 segundos. Luego, las transacciones se transmiten a la red para comenzar la ruta hacia su confirmación."
          },
          {
            "Etapa": "2. Acceso a las Transacciones",
            "Descripción":
              "Los mineros acceden a la mempool y eligen las transacciones para el siguiente bloque. Mientras más llena esté la mempool, más lentas serán las confirmaciones y más altas las comisiones necesarias."
          }
        ]
      }
    },

    {
      heading: "¿Qué utilidad tiene la mempool?",
      text: [
        "La mempool almacena las transacciones de la red hasta que pueden ser procesadas. Gracias a esto, los usuarios pueden realizar sus operaciones con la garantía de que serán atendidas en su debido momento.",
        "También es un mecanismo para regular las comisiones. Cuando la mempool está poco ocupada, las comisiones bajan; cuando está saturada, las comisiones suben porque los usuarios compiten por prioridad.",
        "Otra utilidad clave está relacionada con la seguridad y la resistencia ante ataques DDoS. La mempool puede configurarse para recibir solo una cantidad limitada de transacciones, evitando que la red se sobresature y pierda disponibilidad."
      ]
    },

    {
      heading: "Resumen final",
      text: [
        "La mempool es una parte fundamental del funcionamiento interno de Bitcoin. Sirve como sala de espera para transacciones, regula el tráfico de la red, equilibra el sistema, influye en las comisiones y ayuda a proteger la red frente a ataques.",
        "Sin la mempool, Bitcoin no podría organizar ni priorizar las transacciones de manera eficiente, y la experiencia de uso sería caótica."
      ]
    }
  ]
};

export default CAP_MEMPOOL;
